import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ModelBaselineEffect } from "../types";

export const useModelBaselineEffect = (model_id: number) => {
  return useQuery({
    queryKey: ["model", "charts", "baseline_effects", model_id],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/charts/baseline_effects`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelBaselineEffect;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
